import React, {Component} from 'react';
import {Button,} from "antd";
import {getLeasingCost} from "../../appRedux/actions";
import {connect} from "react-redux";
import './style.css';

class Cost extends Component {
    constructor(props) {
        super(props);
        // this.statusArray = {'': 'dashed', 'EXPIRED': 'danger', 'CLOSED': 'error', 'OPEN': 'primary'};
        this.state = {
            cost: {},
            load: {},
            cachedCost: null,
            // color: 'primary',

        }
    }

    componentDidMount() {
        if (this.props.id) {
            const allCost = this.props.allCost;
            if (!allCost[this.props.id])
                this.props.getLeasingCost(this.props.id);
            else {
                this.setState({
                    cachedCost: allCost[this.props.id]
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.cachedCost && prevProps.cost !== this.props.cost) {
            // console.log('3. ', prevProps, this.props);
            let cst = this.state.cost;
            let ld = this.state.load;
            if (this.props.cost !== null && this.props.cost.cost !== null) {
                cst[this.props.cost.id] = this.props.cost.cost;
                ld[this.props.cost.id] = this.props.cost.loading;
                this.setState({
                    cost: cst,
                    load: ld,
                })

                this.props.addCostToRecord(this.props.id, {
                    cost: cst,
                    load: ld,
                })
            }
        }
    }

    onClick = (asset) => {
        if (asset) {
            const win = window.open(`asset/history-report/${this.props.id}`, "_blank");
            win.focus();
        }
    }

    render() {
        const {cost, load} = this.state;
        return (
            <div>
                {this.state.cachedCost ?
                    <Button style={{width: '150px'}} size={'small'} shape="round" loading={false}
                            onClick={() => this.onClick(this.props.id)}>
                        {this.state.cachedCost.cost[this.props.id] >= 0 && this.state.cachedCost.cost[this.props.id].toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                            style: 'currency',
                            currency: 'INR'
                        }) || <span>&#8377;0.00</span>}
                    </Button>
                    :
                    <Button style={{width: '150px'}} size={'small'} shape="round" loading={load[this.props.id]}
                            onClick={() => this.onClick(this.props.id)}>
                        {cost[this.props.id] >= 0 && cost[this.props.id].toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                            style: 'currency',
                            currency: 'INR'
                        }) || <span>&#8377;0.00</span>}
                    </Button>
                }
            </div>
        );
    }
}


const mapStateToProps = ({auth, leasing}) => {
    return {
        authUser: auth.authUser,
        cost: leasing.assetCost,
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getLeasingCost
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(Cost);
